export function devSimulatePing(minPing = 200) {
	return function (target: any, propertyName: any, descriptor: any): any {
		const originalMethod = descriptor.value;
		descriptor.value = async function (...args: unknown[]) {
			await new Promise((resolve) =>
				setTimeout(resolve, minPing + Math.random() * 300),
			);
			return originalMethod.apply(this, args);
		};
		return descriptor;
	};
}
